/**
 * Check here if we can use ONLY the native implementation:
 * https://caniuse.com/mdn-javascript_builtins_intl_listformat_format
 */

type ListTypes = Exclude<Intl.ListFormatType, 'unit'>;

const getFormatter = (type: ListTypes) => {
  if ('ListFormat' in Intl && typeof Intl.ListFormat === 'function') {
    return new Intl.ListFormat('no', { style: 'long', type });
  }
  return fallbackFormatter(type === 'conjunction' ? 'og' : 'eller');
};

const formatters: Record<ListTypes, Pick<Intl.ListFormat, 'format'>> = {
  conjunction: getFormatter('conjunction'),
  disjunction: getFormatter('disjunction'),
};

/**
 * String joiner for lists. Empty array renders empty string.
 *
 * Type: `conjunction` => **og** (default)
 *
 * Type: `disjunction` => **eller**
 */
export const formatList = (list: string[], type: ListTypes = 'conjunction') => {
  return formatters[type].format(list);
};

export function fallbackFormatter(joiner: 'og' | 'eller') {
  return {
    format: (list: string[]): string => {
      if (list.length < 2) {
        return list.join('');
      }
      const listCopy = [...list];
      const last = listCopy.pop();
      return `${listCopy.join(', ')} ${joiner} ${last}`;
    },
  };
}
